const FILE_SIZE_UNITS = ["B", "KB", "MB", "GB", "TB"];
const FILE_SIZE_UNITS_LONG = ["Bytes", "Kilobytes", "Megabytes", "Gigabytes", "Terabytes"];

export function formatFileSize(sizeInBytes: number, longForm?: boolean): string {
  if (!sizeInBytes && sizeInBytes !== 0) {
    return "";
  }

  const units = longForm ? FILE_SIZE_UNITS_LONG : FILE_SIZE_UNITS;
  if (sizeInBytes === 0) {
    return `0 ${units[0]}`;
  }

  let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
  power = Math.min(power, units.length - 1);

  const size = sizeInBytes / Math.pow(1024, power); // size in new units
  const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
  const unit = units[power];

  return `${formattedSize} ${unit}`;
}
